<h2 mat-dialog-title class="dialog-header">
    <mat-icon class="mr-2" [style.color]="color">{{ icon }}</mat-icon>
    <span class="dialog-title-text">{{ item.title }}</span>
    <button mat-icon-button mat-dialog-close class="close-button" aria-label="Close">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<mat-dialog-content class="details-content">
    <div class="details-layout">
        <aside
            class="details-sidebar"
            [style.background]="'linear-gradient(135deg, ' + color + ' 0%, color-mix(in srgb, ' + color + ' 85%, black) 100%)'"
        >
            <div class="avatar-section">
                <div class="details-avatar">
                    <mat-icon class="avatar-icon">{{ icon }}</mat-icon>
                </div>
                <h3 class="details-name">{{ item.title }}</h3>
                <p class="details-feature" *ngIf="item.featureName">Part of the {{ item.featureName }} feature</p>
                <p class="details-description" *ngIf="item.description">{{ item.description }}</p>
                <p class="details-not-granted" *ngIf="!item.granted">
                    <mat-icon>block</mat-icon> Not given to any security group
                </p>
            </div>

            <mat-divider></mat-divider>

            <div class="quick-stats">
                <div class="stat-row" *ngIf="isFeature">
                    <mat-icon>vpn_key</mat-icon>
                    <span class="stat-label">{{ count(item.permissions.length, 'PERMISSION', 'PERMISSIONS') }}</span>
                </div>
                <div class="stat-row">
                    <mat-icon>security</mat-icon>
                    <span class="stat-label"
                        >{{ count(item.refs.securityGroups.length, 'SECURITY GROUP', 'SECURITY GROUPS') }}</span
                    >
                </div>
                <div class="stat-row">
                    <mat-icon>school</mat-icon>
                    <span class="stat-label">{{ count(item.refs.hats.length, 'HAT', 'HATS') }}</span>
                </div>
                <div class="stat-row">
                    <mat-icon>person</mat-icon>
                    <span class="stat-label">{{ count(item.refs.staff.length, 'USER', 'USERS') }}</span>
                </div>
            </div>
        </aside>

        <main class="details-main">
            <mat-accordion class="sections-accordion" multi>
                <mat-expansion-panel *ngIf="isFeature" data-section="permissions" [(expanded)]="sections.permissions">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon [style.color]="entityColors.getColor('permissions')">vpn_key</mat-icon>
                            Permissions ({{ item.permissions.length }})
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="permission-list" *ngIf="item.permissions.length; else noPermissions">
                        <div class="permission-item" *ngFor="let p of item.permissions; trackBy: trackByKey">
                            <mat-icon class="permission-icon">vpn_key</mat-icon>
                            <div class="item-info">
                                <span class="item-name">{{ p.label }}</span>
                                <span class="item-sub" *ngIf="p.description">{{ p.description }}</span>
                            </div>
                        </div>
                    </div>
                    <ng-template #noPermissions>
                        <div class="empty-section">This feature has no separate permissions</div>
                    </ng-template>
                </mat-expansion-panel>

                <mat-expansion-panel data-section="security-groups" [(expanded)]="sections.securityGroups">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon [style.color]="entityColors.getColor('securityGroups')">security</mat-icon>
                            Security Groups That Give It ({{ item.refs.securityGroups.length }})
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="card-list" *ngIf="item.refs.securityGroups.length; else noGroups">
                        <button
                            type="button"
                            class="ref-item clickable"
                            *ngFor="let g of item.refs.securityGroups; trackBy: trackByKey"
                            [attr.data-group]="g.key"
                            (click)="openSecurityGroup(g)"
                        >
                            <span class="ref-avatar" [style.background]="entityColors.getColor('securityGroups')">
                                <mat-icon>security</mat-icon>
                            </span>
                            <span class="item-name">{{ g.name }}</span>
                            <mat-icon class="open-icon">visibility</mat-icon>
                        </button>
                    </div>
                    <ng-template #noGroups>
                        <div class="empty-section">No security group gives it</div>
                    </ng-template>
                </mat-expansion-panel>

                <mat-expansion-panel data-section="hats" [(expanded)]="sections.hats">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon [style.color]="entityColors.getColor('hats')">school</mat-icon>
                            Hats That Carry It ({{ item.refs.hats.length }})
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="card-list" *ngIf="item.refs.hats.length; else noHats">
                        <button
                            type="button"
                            class="ref-item clickable"
                            *ngFor="let h of item.refs.hats; trackBy: trackByKey"
                            [attr.data-hat]="h.key"
                            (click)="openHat(h)"
                        >
                            <span class="ref-avatar" [style.background]="entityColors.getColor('hats')">
                                <mat-icon>school</mat-icon>
                            </span>
                            <span class="item-name">{{ h.name }}</span>
                            <mat-icon class="open-icon">visibility</mat-icon>
                        </button>
                    </div>
                    <ng-template #noHats>
                        <div class="empty-section">No hat carries it</div>
                    </ng-template>
                </mat-expansion-panel>

                <mat-expansion-panel data-section="staff" [(expanded)]="sections.staff">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon [style.color]="entityColors.getColor('users')">people</mat-icon>
                            Staff Who Have It ({{ item.refs.staff.length }})
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="card-list" *ngIf="item.refs.staff.length; else noStaff">
                        <div class="ref-item" *ngFor="let s of item.refs.staff; trackBy: trackByKey">
                            <span
                                class="ref-avatar user-avatar"
                                [style.background-image]="'url(' + avatarUrl(s) + ')'"
                            ></span>
                            <span class="item-name">{{ s.name }}</span>
                        </div>
                    </div>
                    <ng-template #noStaff>
                        <div class="empty-section">Nobody has it</div>
                    </ng-template>
                </mat-expansion-panel>
            </mat-accordion>
        </main>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
